import React from 'react';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MainListItems from './listItems';
import { Route, useHistory } from "react-router-dom";
import Home from './componentsSPA/homeComponents/Home';
import CryptoJS from 'crypto-js';
import { MasterKeyLogin } from '../constants/constants';
import Plink from '../assets/plinklogo.png';
import Badge from '@material-ui/core/Badge';
import {
    Avatar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    SwipeableDrawer,
    Snackbar,
    CircularProgress
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { useMediaQuery } from 'react-responsive';
import axios from 'axios';
import { encryptData } from '../utils/CryptoHandler';
import { WebSocketProvider, useWebSocket } from '../contextProvider/WebSocketProvider';
import jwt from 'jsonwebtoken'
// --- CONFIGURACIÓN DE LLAVES DESDE .ENV ---
const STORAGE_KEYS = {
    COMMERCE: process.env.REACT_APP_KEY_COMMERCE,
    RIF: process.env.REACT_APP_KEY_RIF,
    USUARIO: process.env.REACT_APP_KEY_USUARIO,
    RAZON: process.env.REACT_APP_KEY_RAZON,
    TOKEN: process.env.REACT_APP_KEY_TOKEN,
    IMAGE: process.env.REACT_APP_KEY_IMAGE,
    NOMBRE: process.env.REACT_APP_KEY_NOMBRE_USUARIO,
    EMPRESA: process.env.REACT_APP_KEY_EMPRESA,
};

const drawerWidth = 240;

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © R4. Banco Microfinanciero ' + new Date().getFullYear() + '. J-31594102-3'}
        </Typography>
    );
}

const StyledBadge = withStyles((theme) => ({
    badge: {
        backgroundColor: '#00c853',
        color: '#00c853',
        marginRight: 8,
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
            borderRadius: '50%', animation: '$ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor', content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': { transform: 'scale(.8)', opacity: 1 },
        '100%': { transform: 'scale(2.4)', opacity: 0 },
    },
}))(Badge);

const useStyles = makeStyles(theme => ({
    root: { display: 'flex', backgroundColor: "white" },
    toolbar: { paddingRight: 24 },
    toolbarIcon: {
        display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '0 8px',
        ...theme.mixins.toolbar, backgroundColor: "white", marginTop: 45
    },
    toolbarIconTitle: { position: "absolute", top: "55px", right: "60px", width: 119, height: 39 },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: "white", boxShadow: "none", marginTop: 45
    },
    appBarShift: {
        marginLeft: drawerWidth, width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: { marginRight: 36 },
    menuButtonHidden: { display: 'none' },
    title: { flexGrow: 1 },
    drawerPaper: {
        position: 'relative', whiteSpace: 'nowrap', width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.enteringScreen,
        }),
        border: "none",
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: { width: theme.spacing(9) },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: { flexGrow: 1, height: '100vh', overflow: 'auto' },
    container: { paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
    avatar: { width: theme.spacing(3.5), height: theme.spacing(3.5), marginRight: 10 },
    sintillo: {
        width: "100%", height: 17, position: "fixed", top: 0, left: 0, zIndex: theme.zIndex.drawer + 2,
        backgroundImage: "linear-gradient(to right, rgb(216, 69, 6), #6730E3, rgba(83, 49, 177, 1))",
    },
    gradientText: {
        background: 'linear-gradient(90deg, #6730E3, #a39be6, #6730E3)',
        backgroundSize: '200% auto', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        animation: '$shine 2s linear infinite', fontWeight: 'bold',
    },
    connectionIndicator: {
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 9999,
    },
    connectionBadge: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#4caf50',
        color: 'white',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
    },
    connectionDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        marginRight: 4,
    },
    '@keyframes shine': { to: { backgroundPosition: '200% center' } },
}));

// Componente interno que usa el WebSocket
function DashboardContent(props) {
    const classes = useStyles();
    const history = useHistory();
    const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1224px)' });
    const { socket, isConnected, onEvent, offEvent } = useWebSocket();

    // --- ESTADOS ---
    const [open, setOpen] = React.useState(isDesktopOrLaptop);
    const [defrifprops, setRifProps] = React.useState();
    const [defrazonprops, setRazonProps] = React.useState();
    const [deftokenprops, setTokenProps] = React.useState();
    const [defimgprops, setImgProps] = React.useState();
    const [defnombreprops, setNombreProps] = React.useState();
    const [defIdEmpresaprops, setIdEmpresa] = React.useState();
    const [defIdusuarioprops, setIdUsuario] = React.useState();
    const [defIdCommerceprops, setIdCommerce] = React.useState();
    const [showTimeoutDialog, setShowTimeoutDialog] = React.useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = React.useState(30);
    const [showSessionInvalidDialog, setShowSessionInvalidDialog] = React.useState(false);
    const [sessionTerminatedReason, setSessionTerminatedReason] = React.useState('');
    const [showConnectionSnackbar, setShowConnectionSnackbar] = React.useState(false);
    const [connectionStatus, setConnectionStatus] = React.useState('connected');

    // --- REFS ---
    const inactivityTimeoutRef = React.useRef(null);
    const countdownRef = React.useRef(null);
    const tokenRef = React.useRef(null);
    const idCommerceRef = React.useRef(null);
    const lastActivityRef = React.useRef(Date.now());
    const showTimeoutDialogRef = React.useRef(false); // Ref para el estado del diálogo

    // Sincronizar Refs con estados
    React.useEffect(() => {
        showTimeoutDialogRef.current = showTimeoutDialog;
    }, [showTimeoutDialog]);

    // Helper para obtener items de storage
    const getStorageItem = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);

    // Sincronizar Refs para el evento pagehide
    React.useEffect(() => {
        tokenRef.current = deftokenprops;
        idCommerceRef.current = defIdCommerceprops;
    }, [deftokenprops, defIdCommerceprops]);



    // --- LÓGICA DE INACTIVIDAD ---
    const resetInactivityTimer = () => {
        // NO resetear si el diálogo ya está abierto
        if (showTimeoutDialogRef.current) {
            console.log("Diálogo abierto - No se resetea el temporizador");
            return;
        }

        // console.log("Inactividad reseteada - Última actividad:", new Date().toISOString());
        lastActivityRef.current = Date.now();

        // Limpiar el temporizador de inactividad anterior
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }

        // Configurar nuevo temporizador de inactividad
        const logoutTime = parseInt(process.env.REACT_APP_TIME_LOGOUT) || 180000;
        // console.log("Nuevo temporizador configurado para:", logoutTime, "ms");

        inactivityTimeoutRef.current = setTimeout(() => {
            // console.log("Temporizador de inactividad disparado - Mostrando diálogo");
            setShowTimeoutDialog(true);
            setTimeoutCountdown(30);

            // Configurar cuenta regresiva
            countdownRef.current = setInterval(() => {
                setTimeoutCountdown(prev => {
                    if (prev <= 1) {
                        // Limpiar todo antes de hacer logout
                        clearInterval(countdownRef.current);
                        logout('inactivity');
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }, logoutTime);
    };

    const extendSession = () => {
        console.log("Sesión extendida por usuario");
        // Limpiar el intervalo de cuenta regresiva
        if (countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
        }
        // Cerrar el diálogo
        setShowTimeoutDialog(false);
        setTimeoutCountdown(30);
        // Reiniciar el temporizador de inactividad
        resetInactivityTimer();
    };

    // Efecto para manejar eventos de actividad
    React.useEffect(() => {
        const handleActivity = () => {
            resetInactivityTimer();
        };

        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

        // Agregar listeners
        events.forEach(event => {
            document.addEventListener(event, handleActivity, true);
        });

        // Iniciar el temporizador inicial
        resetInactivityTimer();

        return () => {
            // Remover listeners y limpiar temporizadores
            events.forEach(event => {
                document.removeEventListener(event, handleActivity, true);
            });

            if (inactivityTimeoutRef.current) {
                clearTimeout(inactivityTimeoutRef.current);
            }

            if (countdownRef.current) {
                clearInterval(countdownRef.current);
            }
        };
    }, []); // Solo se ejecuta una vez al montar

    // Efecto para limpiar cuando el componente se desmonta o el diálogo se cierra
    React.useEffect(() => {
        if (!showTimeoutDialog && countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
        }
    }, [showTimeoutDialog]);

    // --- LÓGICA DE CIERRE DE SESIÓN AUTOMÁTICO (PAGEHIDE) ---
    React.useEffect(() => {
        const handleEndSession = () => {
            let encryptedId = getStorageItem(STORAGE_KEYS.USUARIO);
            if (!encryptedId) return;

            try {
                const bytes = CryptoJS.AES.decrypt(encryptedId.toString(), MasterKeyLogin);
                const id_usuario_final = bytes.toString(CryptoJS.enc.Utf8);

                const LOGOUT_URL = process.env.REACT_APP_URL + process.env.REACT_APP_LOGOUT;
                const currentToken = tokenRef.current;
                const currentIdCommerce = idCommerceRef.current;


                if (currentToken && currentIdCommerce) {
                    fetch(LOGOUT_URL, {
                        method: 'POST',
                        keepalive: true,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${encryptData(currentToken, process.env.REACT_APP_LOGIN_KEY)}`,
                            'id_commerce': encryptData(currentIdCommerce, process.env.REACT_APP_LOGIN_KEY)
                        },
                        body: JSON.stringify({
                            action: 'user_leaving',
                            id_usuario: id_usuario_final,
                            reason: 'pagehide',
                            timestamp: new Date().toISOString()
                        })
                    });
                }
            } catch (e) { console.warn(e); }

            localStorage.clear();
            sessionStorage.clear();
        };

        window.addEventListener('pagehide', handleEndSession);
        return () => window.removeEventListener('pagehide', handleEndSession);
    }, []);

    // --- VALIDACIÓN DE SESIÓN INICIAL ---
    React.useEffect(() => {
        const rif = getStorageItem(STORAGE_KEYS.RIF);

        if (!rif) {
            history.push("/login");
        } else {
            try {
                const decrypt = (val) => CryptoJS.AES.decrypt(val.toString(), MasterKeyLogin).toString(CryptoJS.enc.Utf8);

                setRifProps(decrypt(rif));
                setRazonProps(decrypt(getStorageItem(STORAGE_KEYS.RAZON)));
                setTokenProps(decrypt(getStorageItem(STORAGE_KEYS.TOKEN)));
                setNombreProps(decrypt(getStorageItem(STORAGE_KEYS.NOMBRE)));
                setIdEmpresa(decrypt(getStorageItem(STORAGE_KEYS.EMPRESA)));
                setIdUsuario(decrypt(getStorageItem(STORAGE_KEYS.USUARIO)));
                setIdCommerce(decrypt(getStorageItem(STORAGE_KEYS.COMMERCE)));

                const img = getStorageItem(STORAGE_KEYS.IMAGE);
                if (img && img !== "null") setImgProps(decrypt(img));

            } catch (e) {
                console.error("Session error", e);
                history.push("/login");
            }
        }
    }, [history]);

    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => setOpen(false);

    const logout = async (reason = 'manual') => {
        // Limpiar primero los temporizadores
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
            inactivityTimeoutRef.current = null;
        }

        if (countdownRef.current) {
            clearInterval(countdownRef.current);
            countdownRef.current = null;
        }

        // Cerrar diálogos
        setShowTimeoutDialog(false);
        setShowSessionInvalidDialog(false);

        try {
            let decoded = null;
            if (props.tokenS) {
                
                 decoded = jwt.verify(props.tokenS, process.env.REACT_APP_KEY_ID_COMMERCE);
            }
            const encryptedId = getStorageItem(STORAGE_KEYS.USUARIO);
            const id_usuario_final = CryptoJS.AES.decrypt(encryptedId.toString(), MasterKeyLogin).toString(CryptoJS.enc.Utf8);
            const currentToken = tokenRef.current;
            const currentIdCommerce = idCommerceRef.current;

            await axios.post(process.env.REACT_APP_URL + process.env.REACT_APP_LOGOUT,
                {
                    id_usuario: id_usuario_final,
                    id_sesion: decoded ? decoded.id_sesion : null,
                    reason: reason,
                    timestamp: new Date().toISOString()
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${encryptData(currentToken, process.env.REACT_APP_LOGIN_KEY)}`,
                        'id_commerce': encryptData(currentIdCommerce, process.env.REACT_APP_LOGIN_KEY)
                    },
                }
            );
        } catch (e) {
            console.error('Error en logout:', e);
            // Continuar con la limpieza incluso si hay error
        }

        // Notificar al servidor WebSocket que estamos cerrando sesión
        if (socket) {
            socket.emit('user_logout', {
                userId: defIdusuarioprops,
                reason: reason
            });
        }

        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
    };

    const handleSessionInvalidClose = () => {
        logout('session_terminated_from_other_device');
    };



    return (
        <div className={classes.root}>
            <CssBaseline />
            <div className={classes.sintillo} />



            <Dialog open={showTimeoutDialog}>
                <DialogTitle>Sesión por expirar</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Su sesión se cerrará automáticamente debido a inactividad en {timeoutCountdown} segundos. ¿Desea continuar?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => logout('inactivity')} color="primary">Cerrar sesión</Button>
                    <Button onClick={extendSession} color="primary" autoFocus>Continuar</Button>
                </DialogActions>
            </Dialog>

            {/* Diálogo para sesión cerrada desde otro dispositivo */}
            <Dialog
                open={showSessionInvalidDialog}
                onClose={handleSessionInvalidClose}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <ExitToAppIcon style={{ marginRight: 8, color: '#f44336' }} />
                        Sesión cerrada
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {sessionTerminatedReason || 'Su sesión ha sido cerrada porque inició sesión en otro dispositivo.'}
                        <br /><br />
                        Será redirigido a la página de login.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSessionInvalidClose} color="primary" variant="contained">
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <ChevronRight style={{ color: "#6730E3" }} />
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title} />

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        width="100%"
                        style={{
                            border: "1px solid #000",
                            borderRadius: 20,
                            padding: 8,
                            background: "#fff",
                            height: 50,
                            marginLeft: 50,
                            marginRight: 50,
                            color: "#000"
                        }}
                    >
                        <Avatar src={defimgprops} style={{ marginRight: 36, width: 38, height: 38 }} />
                        <Box flex="1">
                            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{defrazonprops}</Typography>
                            <Typography variant="body2">{defrifprops}</Typography>
                        </Box>
                        <Box flex="2" display="flex" alignItems="center" justifyContent="center">
                            <Typography className={classes.gradientText} variant="subtitle1">
                                {defrazonprops && `r4conecta.io/${defrazonprops.toLowerCase().replace(/\s+/g, '')}`}
                            </Typography>
                        </Box>
                        <Box flex="1" textAlign="right" pr={2}>
                            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>Última conexión</Typography>
                            <Typography variant="body2">{new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}</Typography>
                        </Box>
                    </Box>

                    <Badge color="secondary" badgeContent={0} invisible={true} style={{ marginRight: 20 }}>
                        <NotificationsIcon fontSize="large" />
                    </Badge>

                    <StyledBadge overlap="circle" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
                        <Avatar className={classes.avatar} src={defimgprops} />
                    </StyledBadge>

                    <Tooltip title="cerrar sesión">
                        <IconButton color="inherit" onClick={() => logout('manual')}>
                            <ExitToAppIcon style={{ color: "#000" }} />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>

            {isDesktopOrLaptop ? (
                <Drawer variant="permanent" open={open} classes={{ paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose) }}>
                    <div className={classes.toolbarIcon}>
                        <img src={Plink} className={classes.toolbarIconTitle} alt="Plink" />
                        <IconButton onClick={handleDrawerClose}><ChevronLeft /></IconButton>
                    </div>
                    <List><MainListItems /></List>
                </Drawer>
            ) : (
                <SwipeableDrawer open={open} onClose={handleDrawerClose} onOpen={handleDrawerOpen} classes={{ paper: classes.drawerPaper }}>
                    <div className={classes.toolbarIcon}>
                        <img src={Plink} className={classes.toolbarIconTitle} alt="Plink" />
                        <IconButton onClick={handleDrawerClose}><ChevronLeftIcon /></IconButton>
                    </div>
                    <Divider />
                    <List><MainListItems /></List>
                </SwipeableDrawer>
            )}

            <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Container maxWidth="lg" className={classes.container}>
                    {/* Ruta Principal / Home */}
                    <Route
                        path='/home'
                        render={(props) => (
                            <Home
                                {...props}
                                rif={defrifprops}
                                razon={defrazonprops}
                                token={deftokenprops}
                                id_empresa={defIdEmpresaprops}
                                id_usuario={defIdusuarioprops}
                                page="home"
                                id_commerce={defIdCommerceprops}
                            />
                        )}
                    />

                    {/* Ruta Link de Cobro */}
                    <Route
                        path='/linkcobro'
                        render={(props) => (
                            <Home
                                {...props}
                                rif={defrifprops}
                                razon={defrazonprops}
                                token={deftokenprops}
                                nombre_usuario={defnombreprops}
                                id_usuario={defIdusuarioprops}
                                page="linkcobro"
                                id_commerce={defIdCommerceprops}
                            />
                        )}
                    />

                    {/* Ruta de Gráficos / Charts */}
                    <Route
                        path='/charts'
                        render={(props) => (
                            <Home
                                {...props}
                                rif={defrifprops}
                                razon={defrazonprops}
                                token={deftokenprops}
                                nombre_usuario={defnombreprops}
                                id_commerce={defIdCommerceprops}
                                page="charts"
                            />
                        )}
                    />

                    {/* Ruta de Reportes de Transacciones */}
                    <Route
                        path='/txReports'
                        render={(props) => (
                            <Home
                                {...props}
                                rif={defrifprops}
                                razon={defrazonprops}
                                token={deftokenprops}
                                nombre_usuario={defnombreprops}
                                page="txReports"
                                id_commerce={defIdCommerceprops}
                            />
                        )}
                    />

                    <Box pt={4}>
                        <Copyright />
                    </Box>
                </Container>
            </main>
        </div>
    );
}

// Componente principal que envuelve con WebSocketProvider
export default function Dashboard() {
    const getStorageItem = (key) => localStorage.getItem(key) || sessionStorage.getItem(key);

    // Obtener el userId y token para el WebSocket
    const encryptedId = getStorageItem(STORAGE_KEYS.USUARIO);
    const encryptedToken = getStorageItem(STORAGE_KEYS.TOKEN);
    const encryptedCommerce = getStorageItem(STORAGE_KEYS.COMMERCE);

    let userId = null;
    let token = null;
    let idCommerce = null;


    if (encryptedId) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedId.toString(), MasterKeyLogin);
            userId = bytes.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.error("Error decrypting user ID:", e);
        }
    }

    if (encryptedToken) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedToken.toString(), MasterKeyLogin);
            token = bytes.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.error("Error decrypting token:", e);
        }
    }

    if (encryptedCommerce) {
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedCommerce.toString(), MasterKeyLogin);
            idCommerce = bytes.toString(CryptoJS.enc.Utf8);
        } catch (e) {
            console.error("Error decrypting commerce ID:", e);
        }
    }

    return (
        <WebSocketProvider userId={userId} token={token} idCommerce={idCommerce}>
            <DashboardContent tokenS={token} />
        </WebSocketProvider>
    );
}